import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal"
import luckyWinnerCampaignModel from "@/models/lucky-winner/lucky-winner-campaign"
import router from "@/router"
import store from "@/store"
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable"
import usePagination from "@/views/components/pagination/usePagination"
import useFlatPickr from "@/utils/hooks/useFlatPickr"
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api"
import useModal from "@/@core/components/base-modal/hooks/useModal";

export default function useLuckyWinnerCampaignList() {
  const { openModal, closeModal } = useModal();
  const {
    createCampaign, 
    fetchCampaignList, 
    fetchCampaignDetail, 
    editCampaign, 
    setCampaignStatus
  } = luckyWinnerCampaignModel()
  const { 
    pagination, 
    onPageChange, 
    onFilterEntity 
  } = usePagination()
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal()

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr()
  
  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };
  const loading = reactive({
    tableData: false,
  })

  const campaignSelect = ref(null)

  const fields = [
    { key: "seq", label: "No" },
    { key: "name", label: "Campaign Name" },
    { key: "start_date", label: "Valid From" },
    { key: "end_date", label: "Valid Through" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ]

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ])

  const status = ref(0)

  const campaignListTable = reactive({
    payload: [],
  })

  const fetchLuckyWinnerCampaignList = () => {
    // const response = {
    //     request_id: "4fead79b-fe81-4e81-97c3-b607005a37a6",
    //     status: "success",
    //     data: {
    //       resp: [
    //         {
    //           id: 7,
    //           name: "Test_Edit1007",
    //           startdate: "2022-06-09T00:00:00",
    //           enddate: "2022-07-11T00:00:00",
    //           categoryid: null,
    //           status: true,
    //           createtime: "2022-06-10T17:18:16.1490803",
    //           isdeleted: true
    //         },
    //         {
    //           id: 8,
    //           name: "Test_Edit1008",
    //           startdate: "2022-06-09T00:00:00",
    //           enddate: "2022-07-11T00:00:00",
    //           categoryid: null,
    //           status: true,
    //           createtime: "2022-06-10T17:18:16.1490803",
    //           isdeleted: true
    //         },
    //         {
    //           id: 9,
    //           name: "Test_Edit1009",
    //           startdate: "2022-06-09T00:00:00",
    //           enddate: "2022-07-11T00:00:00",
    //           categoryid: null,
    //           status: true,
    //           createtime: "2022-06-10T17:18:16.1490803",
    //           isdeleted: true
    //         },
    //         {
    //           id: 10,
    //           name: "Test_Edit1010",
    //           startdate: "2022-06-09T00:00:00",
    //           enddate: "2022-07-11T00:00:00",
    //           categoryid: null,
    //           status: true,
    //           createtime: "2022-06-10T17:18:16.1490803",
    //           isdeleted: true
    //         },
    //         {
    //           id: 11,
    //           name: "Test_Edit1011",
    //           startdate: "2022-06-09T00:00:00",
    //           enddate: "2022-07-11T00:00:00",
    //           categoryid: null,
    //           status: true,
    //           createtime: "2022-06-10T17:18:16.1490803",
    //           isdeleted: true
    //         },
    //         {
    //           id: 12,
    //           name: "Test_Edit1012",
    //           startdate: "2022-06-09T00:00:00",
    //           enddate: "2022-07-11T00:00:00",
    //           categoryid: null,
    //           status: true,
    //           createtime: "2022-06-10T17:18:16.1490803",
    //           isdeleted: true
    //         }
    //       ]
    //     },
    //     error: null
    //   }
    loading.tableData = true
    fetchCampaignList.payload.Page = pagination.currentPage
    fetchCampaignList.payload.Limit = pagination.perPage
    fetchCampaignList.payload.Filters = filters
    store
      .dispatch('api/apiRequest', fetchCampaignList)
      .then(response => {
        if(response.status == "success") {
          campaignListTable.payload = response.data.resp.map((item) => ({
            seq: item.id,
            name: item.name,
            start_date: `${resolveDate(item.startdate)} ${resolveTime(item.startdate)}`,
            end_date: `${resolveDate(item.enddate)} ${resolveTime(item.enddate)}`,
            status: item.status
          }))
          pagination.rows = response.data.resp.length
          pagination.totalRows = response.data.filtered_record??response.data.resp.length
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchLuckyWinnerCampaignList()
      }
    },
    { deep: true }
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchLuckyWinnerCampaignList()
    },
    { deep: true }
  )

  const onToggleStatus = (status, reward) => {
    loading.tableData = true
    setCampaignStatus.payload.Id = reward.seq
    setCampaignStatus.payload.Status = reward.status
    store
      .dispatch('api/apiRequest', setCampaignStatus)
      .then(response => {
        if(response.status == "success") {
          reward.status = !reward.status
        }
    })
    .catch(error => {
      openDefaultErrorModal(error)
    })
    .finally(() => {
      loading.tableData = false
    })
  }

  onBeforeMount(() => {
    fetchLuckyWinnerCampaignList()
  })

  return {
    fields,
    loading,
    statusOption,
    status,
    campaignListTable,
    pagination,
    campaignSelect,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
    onToggleStatus,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
  }
}
